module.exports = __webpack_public_path__ + "static/media/truck.ebbf5656.png";